import React from 'react';

const UploadStateContext = React.createContext();
const UploadDispatchContext = React.createContext();

function UploadProvider({ children }) {
  const [uploadState, setUploadState] = React.useState({
    isUploading: false,
    percentage: 0,
    fileName: ''
  });

  return (
    <UploadStateContext.Provider value={uploadState}>
      <UploadDispatchContext.Provider value={setUploadState}>
        {children}
      </UploadDispatchContext.Provider>
    </UploadStateContext.Provider>
  );
}

function useUploadState() {
  const context = React.useContext(UploadStateContext);
  if (context === undefined) {
    throw new Error('useUploadState must be used within an UploadProvider');
  }
  return context;
}

function useUploadDispatch() {
  const context = React.useContext(UploadDispatchContext);
  if (context === undefined) {
    throw new Error('useUploadDispatch must be used within an UploadProvider');
  }
  return context;
}

export { UploadProvider, useUploadState, useUploadDispatch };
